import { Action, createReducer, on } from '@ngrx/store';
import {
  ClearStateAction,
  DiscountAction,
  DiscountErrorAction,
  DiscountSuccessAction,
  getOrderAction,
  getOrderErrorAction,
  getOrderSuccessAction,
  NoFailureAction,
  OrderCompleteAction,
  OrderCompleteErrorAction,
  OrderCompleteSuccessAction,
  OrderDetailsAction,
  OrderDetailsErrorAction,
  OrderDetailsSuccessAction,
  SessionCreateAction,
  SessionCreateErrorAction,
  SessionCreateSuccessAction,
  SessionRetrieveAction,
  SessionRetrieveErrorAction,
  SessionRetrieveSuccessAction,
  VerifyOrderAction,
  VerifyOrderErrorAction,
  VerifyOrderSuccessAction,
  setPeriodId,
  setOrderLocation,
  setAccountID,
  setTimeSlot,
  setDeliveryLocation,
  setTable,
  setChildDeliveryLocation,
  setOrderCompletedOn,
  GuestCheckoutDiscountSuccessAction,
  GuestCheckoutDiscountErrorAction,
  setCustomerInfo,
  addOrderItemAction,
  addOrderItemSuccessAction,
  setReOrderItems,
  SessionCreateGuestCheckoutErrorAction,
  setOrdertID,
  setOrderNotes,
} from './order.actions';
import { OrderState } from './order.state';

const initialState = new OrderState();

const reducer = createReducer(
  initialState,
  on(getOrderAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getOrderSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.order = payload.order;
    return newState;
  }),
  on(getOrderErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(OrderDetailsAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(OrderDetailsSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.orderDetails = payload.orderDetails;
    return newState;
  }),
  on(OrderDetailsErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(VerifyOrderAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(VerifyOrderSuccessAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.orderverified = { data: true };
    return newState;
  }),
  on(VerifyOrderErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.isApplyingDiscount = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(DiscountAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    newState.isApplyingDiscount = true;
    return newState;
  }),
  on(DiscountSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.isApplyingDiscount = false;
    newState.failures = null;
    newState.discountResponse = payload.discountResponse;
    return newState;
  }),
  on(DiscountErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.isApplyingDiscount = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(SessionCreateSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.paymentSessionCreate = payload.paymentSessionCreate;
    return newState;
  }),
  on(SessionCreateErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(SessionRetrieveAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(SessionRetrieveSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.paymentSessionRetrieve = payload.paymentSessionRetrieve;
    return newState;
  }),
  on(SessionRetrieveErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(NoFailureAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(OrderCompleteAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(OrderCompleteSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.completedOrderId = payload.orderId;
    // newState.orderCompletedOn = new Date().toISOString();
    return newState;
  }),
  on(OrderCompleteErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(setAccountID, (state, { accountID }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.accountID = accountID;
    return newState;
  }),
  on(setOrdertID, (state, { orderID }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.orderID = orderID;
    return newState;
  }),
  on(setOrderLocation, (state, { orderLocation }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.orderLocation = orderLocation;
    if (state.orderLocation?.id !== orderLocation.id) {
      newState.timeSlot = null;
    }
    return newState;
  }),
  on(setPeriodId, (state, { periodId }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.periodId = periodId;
    return newState;
  }),
  on(setTimeSlot, (state, { timeSlot }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.timeSlot = timeSlot;
    return newState;
  }),
  on(setDeliveryLocation, (state, { deliveryLocation }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.deliveryLocation = deliveryLocation;
    newState.childDeliveryLocation = null;
    newState.table = null;
    return newState;
  }),
  on(setChildDeliveryLocation, (state, { childDeliveryLocation }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.childDeliveryLocation = childDeliveryLocation;
    return newState;
  }),
  on(setTable, (state, { table }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.table = table;
    return newState;
  }),
  on(setOrderCompletedOn, (state, { orderCompletedOn }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.orderCompletedOn = orderCompletedOn;
    return newState;
  }),
  on(setReOrderItems, (state, { reOrderItems }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.reOrderItems = reOrderItems;
    return newState;
  }),
  on(SessionCreateAction, (state, { sessionCreate }) => {
    const newState = { ...state };
    newState.isLoading = true;
    newState.paymentSessionIntent = sessionCreate.intent;
    return newState;
  }),
  on(ClearStateAction, (state, payload) => {
    const newState = { ...state };
    switch (payload.actionType) {
      case 'isApplyingDiscount':
        newState.isApplyingDiscount = false;
        break;
      case 'discount':
        newState.discountResponse = null;
        break;
      case 'orderDetails':
        newState.orderDetails = null;
        break;
      case 'createSession':
        newState.paymentSessionCreate = null;
        break;
      case 'sessionRetrieve':
        newState.paymentSessionRetrieve = null;
        break;
      case 'deliveryLocation':
        newState.deliveryLocation = null;
        break;
      case 'childDeliveryLocation':
        newState.childDeliveryLocation = null;
        break;
      case 'orderLocation':
        newState.orderLocation = null;
        break;
      case 'table':
        newState.table = null;
        break;
      case 'timeSlot':
        newState.timeSlot = null;
        break;
      case 'orderCompletedOn':
        newState.orderCompletedOn = null;
        break;
      case 'guestCheckoutOrderID':
        newState.guestCheckoutOrderID = null;
        break;
      case 'customerInfo':
        newState.customerInfo = null;
        break;
      case 'orderItems':
        newState.customerInfo = null;
        break;
      case 'reOrderItems':
        newState.reOrderItems = null;
        break;
      case 'orderID':
        newState.orderID = -1;
        break;
      case 'paymentSessionIntent':
        newState.paymentSessionIntent = null;
        break;
      case 'notes':
        newState.notes = null;
        break;
      default:
        break;
    }
    newState.isLoading = false;
    newState.failures = null;
    return newState;
  }),
  on(GuestCheckoutDiscountSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.isApplyingDiscount = false;
    newState.failures = null;
    newState.discountResponse = payload.discountResponse?.discounts;
    newState.guestCheckoutOrderID = payload.discountResponse?.orderID;
    return newState;
  }),
  on(GuestCheckoutDiscountErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.isApplyingDiscount = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(setCustomerInfo, (state, { customerInfo }) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.customerInfo = customerInfo;
    return newState;
  }),
  on(addOrderItemAction, (state, { orderItem }) => {
    const newState = { ...state };
    // newState.orderItems = [...newState.orderItems, orderItem];
    newState.isLoading = false;
    return newState;
  }),
  on(addOrderItemSuccessAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    return newState;
  }),
  on(SessionCreateGuestCheckoutErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(setOrderNotes, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.notes = payload.notes;
    return newState;
  })
);

export function OrderReducer(state: OrderState | null, action: Action) {
  return reducer(state, action);
}
